<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'my-sales',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/issuance-creation/index', label: 'My sales' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/salesOwned/SalesOwned.Entry.vue